/* eslint-disable no-unused-expressions */
import circles from 'assets/images/circles.png';
import dialogIcon from 'assets/images/dialogLogo.svg';
import getReadyImg from 'assets/images/getReadyImg.svg';
import otpicon from 'assets/images/Otp.svg';
import { Button, Input } from 'components/atoms';
import {
  useCheckUser,
  useRequestOTP,
  useVerifyOTP,
  useVerifyOTPWithRegister,
} from 'framework/api/methods';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const OTPPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [otp, setOtp] = useState('');
  const [serverRef, setServerRef] = useState(location.state?.ref);

  const { mutate: verifyOTPWithRegisterMutate, isLoading: verifyOTPWithRegisterIsLoading } =
    useVerifyOTPWithRegister();
  const { mutate: verifyOTPMutate, isLoading: verifyOTPIsLoading } = useVerifyOTP();
  const { mutate: resendOTPMutate, isLoading: resendOTPIsLoading } = useCheckUser();
  const { mutate: resendOTPUnRegMutate, isLoading: resendOTPUnRegIsLoading } = useRequestOTP();

  // request OTP for un registered users
  const handleRequestOTPForRegister = () => {
    verifyOTPWithRegisterMutate(
      {
        data: otp,
        serverRef,
        name: location.state?.name,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          localStorage.setItem('token', successData?.token);
          notify(successData?.message || 'Registered and Logged successfully', 'success');
          navigate('/');
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message) {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // resend otp
  const resendOTPForReg = () => {
    resendOTPMutate(
      {
        mobile: location.state?.phoneNumber,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setServerRef(successData?.serverRef);
          notify(successData?.message || 'OTP has been sent successfully', 'success');
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message) {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // resend otp for un registered
  const resendOTPForUnReg = () => {
    resendOTPUnRegMutate(
      {
        mobile: location.state?.phoneNumber,
        name: location.state?.name,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'OTP has been sent successfully', 'success');
          setServerRef(successData?.serverRef);
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message) {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // request OTP for registered users
  const handleRequestOTP = () => {
    verifyOTPMutate(
      {
        data: otp,
        serverRef,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          localStorage.setItem('token', successData?.token);
          notify(successData?.message || 'User Verified!', 'success');
          navigate(localStorage.getItem('recent-path') || '/');
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message) {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // handle input change
  const handleChange = (e: any) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) {
      setOtp(e.target.value);
    }
  };
  return (
    <div className="flex w-full h-full overflow-hidden relative">
      <div className="w-[55%] relative backdrop-getReady  justify-center items-center text-white hidden lg:flex flex-col gap-y-5">
        <div className="flex tracking-[20px] text-[3rem] font-light text-white text-shadow">
          GET READY
        </div>

        <img src={getReadyImg} alt="get-ready-img" className="w-[300px] h-[300px] z-[2]" />

        <div className="flex flex-col justify-center items-center z-[2]">
          <img src={dialogIcon} alt="dialog-icon" className="w-[100px]" />
          <div className="font-light text-xl text-white w-[70%] text-center">
            Welcome to the Dialog 3D 360 VR video platform
          </div>
        </div>
        <img src={circles} alt="welcome-img" className="w-[120px] absolute bottom-4 left-4 z-[1]" />
      </div>

      <div className="lg:rounded-l-[50px] lg:w-[50%] w-full border absolute h-full right-0 bg-[white] flex flex-col justify-center items-center">
        <div className="flex text-[50px] font-light text-[#F7941E] text-center justify-center items-center w-full">
          OTP
        </div>
        <div className="w-1/2 flex flex-col pt-5 gap-y-3">
          <Input
            icon={otpicon}
            isImgIcon
            placeholder="Enter OTP Number"
            appearance="gray"
            value={otp}
            onChange={handleChange}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && otp) {
                location.state?.isNewUser ? handleRequestOTPForRegister() : handleRequestOTP();
              }
            }}
          />
        </div>

        <Button
          isRounded
          className="mt-10 !px-10"
          size="md"
          disabled={!otp}
          isLoading={verifyOTPIsLoading || verifyOTPWithRegisterIsLoading}
          onClick={() => {
            location.state?.isNewUser ? handleRequestOTPForRegister() : handleRequestOTP();
          }}
        >
          Confirm
        </Button>

        <Button
          appearance="link"
          className="mt-1"
          size="sm"
          isLoading={resendOTPIsLoading || resendOTPUnRegIsLoading}
          onClick={() => {
            location.state?.isNewUser ? resendOTPForUnReg() : resendOTPForReg();
          }}
        >
          Resend OTP
        </Button>
      </div>
    </div>
  );
};

export default OTPPage;
